<template>
  <div>
      <div class="alert alert-info">
        {{message}} <strong v-if="username">[{{username}}]</strong>
      </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      message: '',
      username: ''
    }
  },
  mounted () {
    this.username = this.$route.query.username
    this.message = this.$route.params.message
  }
}
</script>




// WEBPACK FOOTER //
// Message.vue?3362b304